import React, { useRef, useState } from 'react';
import { Box } from '@mui/material';
import ActReportsHeaderActions from './ActReportsHeaderActions';
import ActivityReportsGrid from './ActivityReportsGrid';
import { useNavigate } from 'react-router-dom';

const ActivityReports = () => {

    const [searchText, setSearchText] = useState('');

    const tableRef = useRef(null);

    const navigate = useNavigate();

    const handleOpenColumns  = () => {
        tableRef.current?.openColumnsPanel();
    };

    const handleOpenFilters = () => {
        tableRef.current?.openFiltersPanel();
    };

    const handleStatus = (event) => {
        console.log("handleStatus: ", event);
        !event ? tableRef.current?.setStatusFilter() : tableRef.current?.clearStatusFilter();

    };

    const handleNewRequest = () => {
        navigate("/create-request");
    };

    return (
        <Box>

            <ActReportsHeaderActions 
                searchText={searchText}
                onSearchChange={setSearchText}
                onOpenColumns={handleOpenColumns}
                onOpenFilters={handleOpenFilters}
                onHandleStatus={handleStatus}
                onNewRequest={handleNewRequest}
            />

            <ActivityReportsGrid 
                tableRef={tableRef}
                searchText={searchText}
            />
        </Box>
    )
}

export default ActivityReports